interface EventListenerList
{
	[ key: string ]: Function;
}

function appendEventListener( element: JQuery, events: EventListenerList ) : void
{
	for ( const name in events )
	{
		element.on( name, function() { events[ name ].call( element, arguments ); } );
	}
}

interface GridSizing
{
	xs?: number;
	sm?: number;
	md?: number;
	lg?: number;
}
